export default {
  title: 'Location plan - {municipality}',
  chooseMunicipality: 'Choose a municipality',
  continue: 'Continue',
  moreInfo: 'More information',
  chargingpoint: {
    status: {
      'unknown': 'Unknown',
      'alert': 'Attention required',
      'charging-hub-definitive-private': 'Future charging hub on private property',
      'charging-hub-definitive-semipublic': 'Future charging hub on semi-public property',
      'charging-hub-definitive': 'Future charging hub',
      'charging-hub-disabled-private': 'Disabled charging hub on private property',
      'charging-hub-disabled-semipublic': 'Disabled charging hub on semi-public property',
      'charging-hub-disabled': 'Disabled charging hub',
      'charging-hub-in-progress-private': 'Charging hub in preparation on private property',
      'charging-hub-in-progress-proprietary': 'Company-owned charging hub in preparation',
      'charging-hub-in-progress-semipublic': 'Charging hub in preparation on semi-public property',
      'charging-hub-in-progress': 'Charging hub in preparation',
      'charging-hub-realized-private': 'Existing charging hub on private property',
      'charging-hub-realized-proprietary': 'Existing company-owned charging hub',
      'charging-hub-realized-semipublic': 'Existing charging hub on semi-public property',
      'charging-hub-realized': 'Existing charging hub',
      'charging-hub-rejected-private': 'Rejected charging hub on private property',
      'charging-hub-rejected-semipublic': 'Rejected charging hub on semi-public property',
      'charging-hub-rejected': 'Rejected charging hub',
      'charging-hub-request-private': 'Requested charging hub on private property',
      'charging-hub-request-semipublic': 'Requested charging hub on semi-public property',
      'charging-hub-request': 'Requested charging hub',
      'charging-hub-suggestion-private': 'Proposed charging hub on private property',
      'charging-hub-suggestion-proprietary': 'Proposed company-owned charging hub',
      'charging-hub-suggestion-semipublic': 'Proposed charging hub on semi-public property',
      'charging-hub-suggestion': 'Proposed charging hub',
      'definitive-private': 'Future charging station on private property',
      'definitive-semipublic': 'Future charging station on semi-public property',
      'definitive': 'Future charging station',
      'disabled-private': 'Disabled charging station on private property',
      'disabled-semipublic': 'Disabled charging station on semi-public property',
      'disabled': 'Disabled charging station',
      'fastcharger-definitive-private': 'Future fast charger on private property',
      'fastcharger-definitive-semipublic': 'Future fast charger on semi-public property',
      'fastcharger-definitive': 'Future fast charger',
      'fastcharger-disabled-private': 'Disabled fast charger on private property',
      'fastcharger-disabled-semipublic': 'Disabled fast charger on semi-public property',
      'fastcharger-disabled': 'Disabled fast charger',
      'fastcharger-in-progress-private': 'Fast charger in preparation on private property',
      'fastcharger-in-progress-semipublic': 'Fast charger in preparation on semi-public property',
      'fastcharger-in-progress': 'Fast charger in preparation',
      'fastcharger-realized-private': 'Existing fast charger on private property',
      'fastcharger-realized-semipublic': 'Existing fast charger on semi-public property',
      'fastcharger-realized': 'Existing fast charger',
      'fastcharger-rejected-private': 'Rejected fast charger on private property',
      'fastcharger-rejected-semipublic': 'Rejected fast charger on semi-public property',
      'fastcharger-rejected': 'Rejected fast charger',
      'fastcharger-request-private': 'Requested fast charger on private property',
      'fastcharger-request-semipublic': 'Requested fast charger on semi-public property',
      'fastcharger-request': 'Requested fast charger',
      'fastcharger-suggestion-private': 'Proposed fast charger on private property',
      'fastcharger-suggestion-semipublic': 'Proposed fast charger on semi-public property',
      'fastcharger-suggestion': 'Proposed fast charger',
      'in-progress-private': 'Charging station in preparation on private property',
      'in-progress-semipublic': 'Charging station in preparation on semi-public property',
      'in-progress': 'Charging station in preparation',
      'realized-private': 'Existing charging station on private property',
      'realized-semipublic': 'Existing charging station on semi-public property',
      'realized': 'Existing charging station',
      'rejected-private': 'Rejected charging station on private property',
      'rejected-semipublic': 'Rejected charging station on semi-public property',
      'rejected': 'Rejected charging station',
      'request-private': 'Requested charging station on private property',
      'request-semipublic': 'Requested charging station on semi-public property',
      'request': 'Requested charging station',
      'suggestion-private': 'Proposed charging station on private property',
      'suggestion-semipublic': 'Proposed charging station on semi-public property',
      'suggestion': 'Proposed charging station',
      'participation-suggestion-private': 'Proposed charging station on private property by resident',
      'participation-suggestion-semipublic': 'Proposed charging station on semi-public property by resident',
      'participation-suggestion': 'Proposed charging station by me',
    },
  },
  modal: {
    title: {
      policy: 'Policy rules',
    },
  },
  map: {
    search: 'Search address',
    newLocation: 'New location',
  },
  navbar: {
    title: 'Participation portal',
    titlePreview: 'Participation portal - Preview (opens on {openDate})',
    menuName: 'Menu',
    showPolicy: 'Show policy rules',
    showIntroductionModal: 'Show introduction',
    downloadMap: 'Download map',
    viewer: 'Viewer',
    viewerTitlePreview: 'Viewer - Preview (opens on {openDate})',
  },
  actionSidebar: {
    chargingpointID: 'Location {id}',
    informationAboutLocation: 'Information of the location',
    leaveAMessage: 'Leave a message',
    proposeNewLocation: 'Propose a new location',
    hasCommented: 'You\'ve already commented on this location.',
    disabledMessage: {
      realized: 'This charger is already installed and can thus not be commented on.',
      inProgress: 'This charger will soon be installed and can thus not be commented on anymore.',
      general: 'Comments for this location are disabeld.',
      interactionOnPastParticipations: 'Comments for this charging station are disabeld, because this location has already been participated.',
    },
    form: {
      feedbackPlaceholder: 'Your feedback',
      expiredCaptcha: 'The captcha puzzle has expired, please load again.',
      submitButton: {
        saving: 'Sending...',
        saveLocation: 'Suggest this location',
        locationSaved: 'Your location has been suggested!',
        saveComment: 'Save comment',
        commentSaved: 'Your comment has been saved!',
      },
    },
  },
  locationPopUp: {
    noOutlets: 'Number of outlets:',
  },
  suggestionButton: {
    startSuggesting: 'Suggest a new location',
    stopSuggesting: 'Select a location on the map',
  },
  legend: {
    allLayers: 'All charging points',
    openLegend: 'Open legend',
    closeLegend: 'Close legend',
  },
  downloadMap: {
    title: '{municipality} - Location plan for public chargers',
  },
  closed: {
    title: 'The time to respond to the proposal has elapsed',
    message: 'You can\'t comment anymore.',
  },
  notFound: {
    title: 'Not found (404)',
    message: 'Sorry, this page does not exist (anymore).',
    municipalityNotFound: 'This municipality does not have a viewer or a participation portal.',
    homeButton: 'Go home',
  },
  attachments: {
    top: 'Top View',
    side: 'Side View',
  },
}
